import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin';
import { CMSService } from '../../services/cms-service';
import { Router } from '@angular/router';
import { BC } from 'model/modal-cms/bc';
import { Users } from 'model/modal-cms/users';
import { Conjoint } from 'model/model.conjoint';
import Swal from 'sweetalert2'

declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  data_user: any;
  _bc: BC = new BC(null);
   _users: Users = new Users(null);
   agent: Conjoint = new Conjoint(null);
  id_agent_actuel: any;
  departements: any;
  directions: any;
  services: any;
  listeTypeUser: any;
  code: string = "ABCDEFghojklm123456789";
  constructor(public adminService: AdminService, public _CMSService : CMSService, private router: Router) { 
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
}

  ngOnInit() {
    this.listAllUser();
    this.listAllTypeUser();    
    this.getDep();
  }

  listAllUser() {
    this._CMSService.getUser()
      .subscribe(data => { 
       console.log(data);           
       this.data_user = data;
      },
        err => {
          console.log(err);
        })
  }

  listAllTypeUser(){    
    this._CMSService.getUserType()
      .subscribe(data => { 
       console.log(data);           
       this.listeTypeUser = data;
      },
        err => {
          console.log(err);
        })
  }


  getInfoUser(id_user:any){
    this._CMSService.getUsebyId(id_user)
      .subscribe(data => { 
      this._users = data    
     },
        err => {
          console.log(err);
        })
  }


  getDep(){
    this.adminService.getListeDepartement("",0,0).subscribe(data=>{
      this.departements=data;
      //this.getConjoint();
    },err=>{
  
    })
  }


  getListDirection(depId){
    this.adminService.getListeDirection(depId,0,0).subscribe(data=>{
      this.directions=data;
    //  var dep=this.getPosDepartementByNom(this.conjoint.agent_departement);
    //this.posDepartements=dep;
    },err=>{
  
    })
  }


  getListService(depId,directionId){
    this.adminService.getListeService(depId,directionId,0,0).subscribe(data=>{
      this.services=data;
      console.log("service cms" + this.services)
    },err=>{
  
    })
  }

   onKey(event: any) {
      console.log(event.target.value);
      let key2 = event.target.value;
      let count = event.target.value.length;
      console.log(count);
      if (count >= 6) {
        console.log(event.target.value.length);
       
      this.adminService.getConjoinsParIm(key2)
        .subscribe(data => {
          this.agent.agent_nom = data.agent_nom;
          this.agent.agent_prenom = data.agent_prenom;
          this.agent.id = data.id;
        }, err => {
          console.log(err);
        })
    
      }
    }


  EnregisterUser(dirg,dir){
    console.log(dirg,dir);
    this._users.sigle_user = dirg+"/"+dir;

    if(dirg=="DIRECTION ADMINISTRATIVE ET FINANCIERE"){
          this._users.dir_user = "DAF";
    }else if(dirg=="DIRECTION DES SYSTEMES D'INFORMATION"){
         this._users.dir_user= "DSI";
    }else if(dirg=="DIRECTION DES RESSOURCES HUMAINES"){
          this._users.dir_user = "DRH";
    }
  //  this._users.dir_user = dir
     console.log("service cms" + this._users.sigle_user);
      console.log("service cms" + this._users);
     if (this._users.id_user == null ) {
        this._CMSService.saveUser(this._users).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          this.listAllUser();
          this._users = new Users(null);
          success_message.show();
        }, err => {
        })
      } else {
        this._CMSService.updateUser(this._users).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          this.listAllUser();
          this._users = new Users(null);
          success_message.show();
        }, err => {
        })
      }

  }




 DeleteUser(u: Users) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this._CMSService.deleteUser(u.id_user)
        .subscribe(data => {
          this.listAllUser();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }

}
